
import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";

import logo from "../../../../assets/logo.png";
import userIcon from "../../../../assets/icons/user.png";
import mailIcon from "../../../../assets/icons/mail.png";

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontFamily: "Helvetica",
        fontSize: 12,
        color: "#2D2D38",
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 16,
        paddingBottom: 10,
        borderBottomWidth: 2,
        borderBottomColor: "#B91D1C",
    },
    logo: { width: 60, height: 60, marginRight: 15 },
    headerTitle: {
        fontSize: 20,
        fontFamily: "Helvetica-Bold",
        color: "#B91D1C",
    },

    sectionTitle: {
        fontSize: 16,
        fontFamily: "Helvetica-Bold",
        marginTop: 16,
        marginBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: "#B91D1C",
        paddingBottom: 3,
    },

    infoRow: { flexDirection: "row", marginBottom: 8, alignItems: "center" },
    icon: { width: 12, height: 12, marginRight: 6 },
    infoLabel: { fontFamily: "Helvetica-Bold", marginRight: 4 },

   
    table: {
        borderWidth: 1,
        borderColor: "#E5E7EB",
        borderRadius: 6,
        overflow: "hidden",
        marginTop: 6,
    },
    tableHeader: {
        flexDirection: "row",
        backgroundColor: "#10B981",
        paddingVertical: 8,
        paddingHorizontal: 10,
    },
    th: {
        color: "#FFFFFF",
        fontFamily: "Helvetica-Bold",
        fontSize: 12,
    },
    tableRow: {
        flexDirection: "row",
        paddingVertical: 8,
        paddingHorizontal: 10,
        borderTopWidth: 1,
        borderTopColor: "#E5E7EB",
        backgroundColor: "#FFFFFF",
    },
    td: { fontSize: 11, color: "#2D2D38" },

    colName: { width: "60%", paddingRight: 10 },
    colDate: { width: "40%" },

    pageFooter: {
        position: "absolute",
        bottom: 18,
        left: 30,
        right: 30,
        fontSize: 10,
        color: "#777",
        flexDirection: "row",
        justifyContent: "space-between",
    },
});

const norm = (v) => (v == null ? "" : String(v));

const getNombre = (p) =>
    (
        p?.nombre ??
        p?.nombreEvaluado ??
        p?.NombreEvaluado ??
        p?.PrimerNombre ??
        p?.primerNombre ??
        ""
    ).trim();

export default function PdfReporteEvaluacionFormulario({ formulario, personas }) {
    const formName = formulario?.nombre || "Formulario";

    
    const lista = [...(personas || [])].sort((a, b) =>
        norm(b?.fecha).localeCompare(norm(a?.fecha))
    );

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                
                <View style={styles.headerContainer}>
                    <Image src={logo} style={styles.logo} />
                    <Text style={styles.headerTitle}>Reporte de Evaluación</Text>
                </View>

                
                <Text style={styles.sectionTitle}>Información General</Text>

                <View style={styles.infoRow}>
                    <Image src={mailIcon} style={styles.icon} />
                    <Text style={styles.infoLabel}>Formulario:</Text>
                    <Text>{norm(formName)}</Text>
                </View>

                <View style={styles.infoRow}>
                    <Image src={userIcon} style={styles.icon} />
                    <Text style={styles.infoLabel}>Total de personas:</Text>
                    <Text>{lista.length}</Text>
                </View>

                
                <Text style={styles.sectionTitle}>Personas que completaron el formulario</Text>

                <View style={styles.table}>
                    <View style={styles.tableHeader}>
                        <View style={styles.colName}>
                            <Text style={styles.th}>Evaluado</Text>
                        </View>
                        <View style={styles.colDate}>
                            <Text style={styles.th}>Fecha última evaluación</Text>
                        </View>
                    </View>

                    {lista.map((p, idx) => (
                        <View key={p.idEvaluado || idx} style={styles.tableRow} wrap={false}>
                            <View style={styles.colName}>
                                <Text style={styles.td}>
                                    {getNombre(p) || `ID ${norm(p.idEvaluado)}`}
                                </Text>
                            </View>
                            <View style={styles.colDate}>
                                <Text style={styles.td}>{norm(p.fecha) || "—"}</Text>
                            </View>
                        </View>
                    ))}
                </View>

                <View style={styles.pageFooter}>
                    <Text>Formulario: {norm(formName)}</Text>
                    <Text render={({ pageNumber, totalPages }) => `Página ${pageNumber} / ${totalPages}`} />
                </View>
            </Page>
        </Document>
    );
}
